import * as React from 'react';
import { PriceType } from "../../../classes/price-type";
import { IOption } from '../../../classes/seating-option';
import { IExchangeTicket } from '../../../classes/ticket-exchange';
import PriceRange from '../../../common/filters/price-range';
import { IPriceRangeModel } from '../../../filter/reducers/filter-reducers';
import { formatString } from '../../../helpers/string-format';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import PriceTypeFilter from './price-type-filter';
import LevelSelect from '../../components/level-select';
import { Level } from '../../../classes/level';
import { CartSeat } from '../../../classes/seat';
import { IAppState } from '../../../reducers/index';
import { toggleSeatmapFilters } from '../../../seatmap/actions/seatmap-actions';
import { convertNumberListToString } from '../../../helpers/array-helpers';

interface IFiltersOverlayProps {
    appSettings: IAppSettingsModel;
    onPriceRangeClear: (minPrice: number, maxPrice: number) => any;
    onSelectMinPrice: (number) => any;
    onPriceTypeToggle: (selectedOptions: IOption[]) => any;
    onLevelSelectOpenToggle: () => any;
    onSelectMaxPrice: (number) => any;
    priceRangeModel: IPriceRangeModel;
    startingMinPrice: number;
    startingMaxPrice: number;
    activeExchangeTickets: Array<IExchangeTicket>;
    priceTypes: Array<PriceType>;
    showComponent: boolean;
    selectedPriceTypes: Array<PriceType>;
    showLevelSelectFilter: boolean;
    levelSelectFilterOpen: boolean;
    showPriceRangeFilter: boolean;
    showPriceTypeFilter: boolean;
    dispatch: any;
    levels: Array<Level>;
    currentSeatmapId: string;
    cartSeats: Array<CartSeat>;
    onLevelSelectModalOpen: () => any;
    seatmapFiltersIsOpen: boolean;
    seatmapFiltersText: string;
}

interface IFiltersOverlayState {
    openPriceRangeFilter: boolean;
    openPriceTypeFilter: boolean;
}

class FiltersOverlay extends React.Component<IFiltersOverlayProps, IFiltersOverlayState> {
    constructor(props) {
        super(props);

        this.state = {
            openPriceRangeFilter: false,
            openPriceTypeFilter: false,
        }
    }

    shouldComponentUpdate(nextProps: IFiltersOverlayProps, nextState: IFiltersOverlayState) {
        return this.props.showComponent != nextProps.showComponent
            || this.props.selectedPriceTypes.length !== nextProps.selectedPriceTypes.length
            || this.props.showLevelSelectFilter != nextProps.showLevelSelectFilter
            || this.props.levelSelectFilterOpen != nextProps.levelSelectFilterOpen
            || this.state.openPriceRangeFilter != nextState.openPriceRangeFilter
            || this.state.openPriceTypeFilter != nextState.openPriceTypeFilter
            || this.props.priceRangeModel.lowerRangeLimit !== nextProps.priceRangeModel.lowerRangeLimit
            || this.props.priceRangeModel.upperRangeLimit !== nextProps.priceRangeModel.upperRangeLimit;
    }

    _togglePriceRangeFilter() {
        this.setState({
            openPriceRangeFilter: !this.state.openPriceRangeFilter
        })
    }

    _togglePriceTypeFilter() {
        this.setState({
            openPriceTypeFilter: !this.state.openPriceTypeFilter
        })
    }

    _toggleSeatmapFilters(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapFilters());
    }

    handleClickOutside = evt => {
        if (this.props.showComponent) {
            this.props.dispatch(toggleSeatmapFilters());
        }
    };

    render() {
        const useTag = `<title id="expandAdditionalOptions">${formatString(this.props.appSettings.altText !== null ? this.props.appSettings.altText.expandSectionArrow : '', [this.props.appSettings.filterAdditionalSeatingOptionsTitle])}</title> <use xlink:href="#icon-arrow-down" />`;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;

        return (
            <div className="overlay-section">
                <div className="overlay-section-header">
                    <a href="#" onClick={(evt) => this._toggleSeatmapFilters(evt)}>
                        <h2 className="heading-general">{this.props.seatmapFiltersText}</h2>
                        <div dangerouslySetInnerHTML={{ __html: xSvg }} ></div>
                    </a>

                </div>

                {this.props.showLevelSelectFilter ?
                    <div className="overlay-filter-section">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.props.levelSelectFilterOpen} className="filter-title" onClick={this.props.onLevelSelectOpenToggle.bind(this)}>
                                {this.props.appSettings.levelsHeading}
                                <svg className={"filters-section-heading-toggles-icon" + (this.props.levelSelectFilterOpen ? " toggled" : "")} aria-labelledby="expandAdditionalOptions" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.props.levelSelectFilterOpen}>
                            <LevelSelect {...this.props.appSettings}
                                dispatch={this.props.dispatch}
                                levels={this.props.levels}
                                cartSeats={this.props.cartSeats}
                                currentSeatmapId={this.props.currentSeatmapId}
                                onLevelSelectModalOpen={this.props.onLevelSelectModalOpen}
                                levelAvailableCountMessage={this.props.appSettings.levelAvailableCountMessage}
                                selectedPriceTypeIdsString={convertNumberListToString(this.props.priceTypes.filter(pt => pt.selectedQuantity > 0).map(pt => pt.priceTypeId))}
                                selectedLevelString={this.props.levels.filter(level => {
                                    return level.selected;
                                }).map(level => {
                                    return level.levelNumber;
                                }).toString()}

                            />


                        </div>
                    </div>
                    : null}

                {this.props.showPriceRangeFilter ?
                    <div className="overlay-filter-section">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.state.openPriceRangeFilter} className="filter-title" onClick={this._togglePriceRangeFilter.bind(this)}>
                                {this.props.appSettings.seatmapPriceRangeFilterHeader}
                                <svg className={"filters-section-heading-toggles-icon" + (this.state.openPriceRangeFilter ? " toggled" : "")} aria-labelledby="expandAdditionalOptions" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.state.openPriceRangeFilter}>
                            <PriceRange {...this.props.appSettings}
                                {...this.props.priceRangeModel}
                                onPriceRangeClear={this.props.onPriceRangeClear}
                                onSelectMaxPrice={this.props.onSelectMaxPrice}
                                onSelectMinPrice={this.props.onSelectMinPrice}
                                startingMinPrice={this.props.startingMinPrice}
                                startingMaxPrice={this.props.startingMaxPrice}
                                showClearButton={false}
                                showTitle={false}
                                titleText={this.props.appSettings.seatmapPriceRangeFilterHeader}>
                            </PriceRange>
                        </div>
                    </div>
                    : null}
                {this.props.showPriceTypeFilter && this.props.showComponent ?
                    <div className="overlay-filter-section overlay-filter-section-last">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.state.openPriceTypeFilter} className="filter-title" onClick={this._togglePriceTypeFilter.bind(this)}>
                                {this.props.appSettings.seatmapTicketTypeFilterHeader}
                                <svg className={"filters-section-heading-toggles-icon" + (this.state.openPriceTypeFilter ? " toggled" : "")} aria-labelledby="expandAdditionalOptions" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.state.openPriceTypeFilter}>
                            <PriceTypeFilter onPriceTypeToggle={this.props.onPriceTypeToggle} priceTypes={this.props.priceTypes}
                                selectedPriceTypeIds={this.props.selectedPriceTypes.map(pt => pt.priceTypeId.toString())}
                                description={this.props.appSettings.seatmapTicketTypeFilterInstructions}
                                allTicketsText={this.props.appSettings.seatmapTicketTypeAllTicketsLabel}
                            />
                        </div>
                    </div>
                    : null
                }
            </div>
        )
    }
}

export default FiltersOverlay;